export default {
  OK: "OK",
  ok: "OK",
  loginFailed: "Login failed, please try again.",
  requestFailed: "Request failed, please check your internet connection.",
  invalidLogin: "Invalid Username or Password.",
  invalidPassword: "Invalid Username or Password.",
  thisFunctionExists: "This function is already exists.",
  thisFunctionNotAllowDelete: "This function is not allow to delete.",
  thisFunctionNotExists: "This function is not exists.",
  targetFunctionIdRequired: "Target Function ID is required.",
  thisPageExists: "This page is already exists.",
  thisPageNotAllowDelete: "This page is not allow to delete.",
  thisRoleExists: "This role is already exists.",
  thisRoleNotAllowDelete: "This role is not allow to delete.",
  targetRoleIdRequired: "Target Role ID is required.",
  invalidParameter: "Invalid Parameter.",
  systemError: "System unable to process your request.",
  spErrorMessage: "SP Message Error (Depend what error).",
  actionbyRequired: "Current User is required.",
  sessionTokenRequired: "Session Token is required.",
  functionIdRequired: "Function ID is required.",
  functionNameRequired: "Function name is required.",
  newFunctionNameRequired: "Function name is required.",
  pageIdRequired: "Page ID is required.",
  newPageIdRequired: "Page ID is required.",
  newPageNameRequired: "Page name is required.",
  targetPageIdRequired: "Target Page ID is required.",
  userIdRequired: "User ID is required",
  passwordRequired: "Password is required.",
  userNameRequired: "Full Name is required.",
  passwordValidation: "Password must be 6-20 characters and a combination of number(s) and letter(s).",
  pageNumRequired: "Page Number is required.",
  pageSizeRequired: "Page Size is required.",
  roleIdRequired: "Role ID is required",
  oldPasswordRequired: "Current Password is required.",
  userStatusRequired: "User Status is required.",
  newRoleIdRequired: "Role ID is required.",
  newRoleNameRequired: "Role Name is required.",
  startDateRequired: "Start Date is required.",
  endDateRequired: "End Date is required.",
  startDateIsGteEndDate: "Start Date is greater than End Date.",
  thisRoleNotExists: "This Role is not exists.",
  thisPageNotExists: "This Page is not exists.",
  thisUserExists: "This User is already exists.",
  thisUserNotExists: "This User is not exists.",
  thisUserBlackListed: "Your account has been suspended.",
  thisUserInactive: "Your account has been disabled.",
  thisUserBlocked: "Your account has been blocked.",
  thisUserNotActive: "Your account has been disabled.",
  InvalidPageFunction:"Invalid Page Function.",
  invalidUser: "Invalid User!",
  invalidToken: "Invalid Session!",
  NoUserAccessRight: "Permission Denied!",
  unableSPProcess: "System unable to process your request.",
  connection: "Connection Error",
  loginIdRequired: "Login ID is required.",
  loginNameRequired: "Login Name is required.",
  targetLoginIdRequired: "Target Login ID is required.",
  newHostIdRequired: "Host ID is required.",
  newLoginNameRequired: "Login Name is required.",
  loginDisabledRequired: "Login Disabled is required.",
  thisLoginExists: "This Login is already exists.",
  thisLoginNotExists: "This Login is not exists.",
  sourceAccountIdRequired: "Source Account ID is required.",
  targetAccountIdRequired: "Target Account ID is required.",
  authTokenRequired: "Auth token is required.",
  accountIdRequired: "Account ID is required.",
  minDepositRequired: "Minimum Deposit is required.",
  minWithdrawalRequired: "Minimum Withdrawal is required.",
  minBalanceRequired: "Minimum Balance is required.",
  invalidSourceAccountId: "Invalid Source Account ID.",
  invalidTargetAccountId: "Invalid Target Account ID.",
  subLoginIdRequired: "Sub Login ID is required.",
  invalidAccountId: "Invalid Account ID.",
  invalidSubLoginId: "Invalid Sub Login ID.",
  parentIdRequired: "Parent ID is required.",
  invalidParentId: "Invalid Parent ID.",
  newLoginIdRequired: "New Login ID is required.",
  newPasswordRequired: "New Password is required.",
  securityTagRequired: "Security Tag is required.",
  securityCodeRequired: "Security Code is required.",
  authorityOptionRequired: "Authority Option is required.",
  profileIdRequired: "Profile ID is required.",
  newStatusRequired: "New Status is required.",
  selfOperateRequired: "Self Operate is required.",
  amountRequired: "Amount is required.",
  bankIdRequired: "Bank ID is required.",
  bankAccNoRequired: "Bank Account No. is required.",
  bankAccHolderRequired: "Bank Account Holder is required.",
  newBankIdRequired: "New Bank ID is required.",
  newNBankAccNoRequired: "New Bank Account No. is required.",
  newBankAccHolderRequired: "New Bank Account Holder is required.",
  bankNameRequired: "Bank Name is required",
  incomingAmountThresholdRequired: "Incoming Amount Threshold is required.",
  incomingFrequencyThresholdRequired: "Incoming Frequency Threshold is required.",
  outgoingAmountThresholdRequired: "Outgoing Amount Threshold is required.",
  outgoingFrequencyThresholdRequired: "Outgoing Frequency Threshold is required.",
  accountBalanceRequired: "Account Balance is required.",
  contactPhoneRequired: "Contact Phone is required.",
  memberIdRequired: "Member ID is required.",
  referrerCodeRequired: "Referrer Code is required.",
  packageIdRequired: "Package ID is required.",
  fullNameMinThreeChar: "Full name must have at least 3 characters.",
  nicknameMinThreeChar: "Nickname must have at least 3 characters.",
  searchCriteriaRequired: "Search criteria is required.",
  reviewIdRequired: "Review ID is required.",
  auditByRequired: "Audit by is required.",
  accountTypeRequired: "Account type is required.",
  invalidAccountType: "Invalid account type",
  affiliateCodeRequired: "Affiliate code is required.",
  contactPhoneRequired: "Contact phone is required.",
  tacCodeRequired: "TAC code is required.",
  targetAffiliateIdRequired: "Target Affiliate ID is required.",
  playerIdRequired: "Player ID is required.",


  serverBusy: "Server is busy now. Please try again.",

  isRequired: "Please enter a {fname}.",
  isMinValue: "{fname} must have minimal of {fvalue}.",
  isMaxValue: "{fname} must be less than or equal to {fvalue}.",
  isMinLength: "{fname} must have at least {fvalue} characters.",
  isMaxLength: "{fname} must be less than or equal to {fvalue} characters.",
  isAlpha: "{fname} accept only alphabet.",
  isAlphaNum: "{fname} accept only alphanumerics.",
  isNumeric: "{fname} accept only numerics.",
  isEmail: "{fname} accept only valid email addresses.",
  isIpAddress: "{fname} accept only valid IPv4 addresses.",
  isSameAs: "{fname} must be same as {fname2}.",
  isUrl: "{fname} accept only URLs.",
  containAlphaNum: "{fname} must have at least one alphabet and one number.",
  alphaNumWithSpace: "{fname} accept only alphanumerics.",
  isDecimal: "{fname} accept only numerics.",
  isInteger: "{fname} accept only integer.",
  selectOption: "Please select a {fname}",
  notSameAs: "{fname} and {fname2} cannot be the same.",
  dateRangeAllowOneMonth: "Date range only allow select up to 1 month.",
  greaterThanZero: "{fname} must be greater than zero.",
  atLeastOneAuthority: "Must select at least one authority.",
  isValidMYHP: "{fname} accept only valid mobile phone number.",
  permissionDenied: "You are not authorised to perform this action.",
  BLOCK: "Your account has been blocked.",
  SUSPEND: "Your account has been suspended.",
  CLOSE: "Your account has been closed.",
  PENDING: "Your account is pending for approval.",

  must_enable_at_least_one: "Must enable at least one option.",
  insufficient_balance: "Insufficient balance.",
  source_account_id_required: "Source Account ID is required.",
  source_account_id_not_exists: "Source Account ID not exists.",
  source_account_inactive: "Source Account is inactive.",
  target_account_id_required: "Target Account ID is required.",
  target_account_id_not_exists: "Target Account ID not exists.",
  target_account_inactive: "Target Account is inactive.",
  target_account_not_exists: "Target Account not exists",
  account_id_required: "Account ID is required.",
  account_not_exists: "Account not exists.",
  sub_login_id_required: "Sub Login ID is required.",
  login_id_required: "Login ID is required.",
  login_id_not_exists: "Login ID not exists.",
  profile_not_exists: "Profile not exists.",
  account_inactive: "Account is inactive",
  password_required: "Password is required.",
  invalid_password: "Invalid password.",
  permission_denied: "Permission denied.",
  min_deposit_required: "Minimum deposit is required.",
  min_withdrawal_required: "Minimum withdrawal is required.",
  min_balance_required: "Minimum balance is required.",
  account_not_blocked: "Account is not blocked.",
  parent_id_not_exists: "Parent ID not exists",
  parent_id_required: "Parent ID is required.",
  incorrect_parent: "Incorrect Parent",
  not_blocked_account: "Not a blocked account",
  target_profile_not_exists: "Target profile not exists",
  self_operate_required: "Self Operate is required.",
  parent_not_exists: "Parent not exists",
  account_id_exists: "Account ID exists",
  new_login_id_required: "New Login ID is required.",
  new_password_required: "New password is required.",
  security_tag_required: "Security Tag is required.",
  security_code_required: "Security Code is required.",
  secondary_account_exists: "Secondary account exists",
  new_login_id_exists: "New login ID exists",
  authority_option_required: "Authority Option is required.",
  audit_by_required: "Audit by is required.",
  bank_id_required: "Bank ID is required.",
  bank_acc_no_required: "Bank account No. is required.",
  bank_acc_holder_required: "Bank account holder is required.",
  new_bank_id_required: "New Bank ID is required.",
  new_bank_acc_no_required: "New Bank account No. is required.",
  new_bank_acc_holder_required: "New Bank account holder is required.",
  bank_name_required: "Bank name is required.",
  amount_required: "Amount is required.",
  bank_account_not_exists: "Bank account not exists.",
  member_not_exists: "Member not exists",
  member_account_inactive: "Member account is inactive",
  member_wallet_not_exists: "Member wallet not exists.",
  start_date_gt_end_date: "Start date greater than end date.",
  start_date_required: "Start date is required.",
  end_date_required: "End date is required.",
  bank_acc_type_required: "Bank account type is required.",
  incoming_amount_threshold_required: "Incoming amount threshold is required.",
  incoming_frequency_threshold_required: "Incoming frequency threshold is required.",
  outgoing_amount_threshold_required: "Outgoing amount threshold is required.",
  outgoing_frequency_threshold_required: "Outgoing frequency threshold is required.",
  account_balance_required: "Account balance is required.",
  bank_account_exists: "Bank account exists.",
  bank_member_exists: "Bank member is exists.",
  no_changes: "No changes.",
  bonus_name_required: "Bonus Name is required.",
  bonus_value_required: "Bonus Value is required.",
  criteria_required: "Criteria is required.",
  rollover_required: "Rollover is required.",
  remark_required: "Remark is required.",
  invalid_criteria: "Invalid criteria.",
  ongoing_promotion: "Ongoing promotion.",
  profile_inactive: "Profile is inactive.",
  parent_account_not_exists: "Parent account not exists.",
  parent_account_inactive: "Parent account is inactive.",
  parent_profile_not_exists: "Parent profile not exists.",
  parent_profile_inactive: "Parent profile is inactive.",
  profile_id_required: "Profile ID is required.",
  incorrect_password: "Incorrect password.",
  base_amount_required: "Base amount is required.",
  bonus_amount_required: "Bonus amount is required.",
  no_ongoing_promo: "No ongoing promotion.",
  package_id_required: "Package ID is required.",
  promo_package_not_exists: "Promotion package not exists.",
  promo_package_inactive: "Promotion package is inactive.",
  promo_package_downloaded: "Promotion package is downloaded.",
  promo_id_required: "Promo ID is required.",
  new_status_required: "New status is required.",
  invalid_security_code: "Invalid security code.",
  auth_token_required: "Auth token is required.",
  auth_status_required: "Auth status is required.",
  invalid_session: "Invalid Session.",
  session_expired: "Session Expired.",
  action_required: "Action is required.",
  invalid_account_status: "Invalid account status.",
  ticket_id_required: "Ticket ID is required.",
  ticket_not_exists: "Ticket not exists.",
  ticket_processed: "Ticket is processed.",
  min_deposit_not_met: "Minimum deposit not met.",
  invalid_promo_package: "Invalid promotion package.",
  promo_min_deposit_not_met: "Promotion minimum deposit not met.",
  claim_promo_only_once_a_day: "Promotion only allow to claim once per day.",
  first_deposit_unmet: "First deposit promotion criteria unmet.",
  newbie_unmet: "Newbie promotion criteria unmet.",
  claim_promo_only_once: "Promotion only allow to claim once.",
  multiplier_not_found: "Multiplier not found.",
  inner_catch: "Inner catch.",
  sender_bank_id_required: "Sender Bank ID is required.",
  sender_bank_acc_no_required: "Sender Bank Account No. is required.",
  sender_bank_acc_holder_required: "Sender Bank Account Holder is required.",
  min_withdrawal_not_met: "Minimum withdrawal amount not met.",
  promotion_requirement_not_met: "Promotion requirement not met.",
  invalid_promotion: "Invalid promotion.",
  fund_transfer_record_not_exists: "Fund transfer record not exists.",
  point_transfer_record_not_exists: "Point transfer record not exists.",
  working_date_required: "Working date is required.",
  contact_phone_required: "Contact phone is required.",
  vip_mode_required: "VIP mode is required.",
  invalid_vip_mode: "Invalid VIP mode.",
  level_1_requirement_required: "Level 1 requirement is required.",
  level_1_multp_required: "Level 1 multiplier is required.",
  level_2_requirement_required: "Level 2 requirement is required.",
  level_2_multp_required: "Level 2 multiplier is required.",
  level_3_requirement_required: "Level 3 requirement is required.",
  level_3_multp_required: "Level 3 multiplier is required.",
  level_4_requirement_required: "Level 4 requirement is required.",
  level_4_multp_required: "Level 4 multiplier is required.",
  level_5_requirement_required: "Level 5 requirement is required.",
  level_5_multp_required: "Level 5 multiplier is required.",
  level_6_requirement_required: "Level 6 requirement is required.",
  level_6_multp_required: "Level 6 multiplier is required.",
  level_7_requirement_required: "Level 7 requirement is required.",
  level_7_multp_required: "Level 7 multiplier is required.",
  already_setup: "Already setup.",
  vip_not_exists: "VIP not exists.",
  ibank_deposit: "Permission Denied.",
  sub_profile_inactive: "Sub Profile Inactive",
  referrer_code_required: "Referrer Code is required.",
  referrer_not_exists: "Referrer not exists.",
  min_balance_not_met: "Minimum Balance not met.",
  search_criteria_required: "Search criteria is required.",
  review_id_required: "Review ID is required.",
  bank_account_inactive: "Bank Account is inactive.",
  affiliate_code_required: "Affiliate Code is required.",
  affiliate_code_exists: "Affiliate Code exists.",
  sub_account_id_not_exists: "Sub Account ID not exists.",
  sub_profile_not_exists: "Sub Profile not exists.",
  affiliate_id_required: "Affilaite Id is required.",
  exceed_max_withdrawal: "Exceed maximum withdrawal amount.",
  bank_not_exists: "Bank is not exists.",
  bank_inactive: "Bank is inactive.",
  wallet_not_exists:"Wallet is not exists.",
  withdrawal_period_closed: "Withdrawal period is closed.",
  tac_not_validate: "TAC code not validate yet.",
  tac_validated: "TAC code is validated.",
  tac_is_valid: "Previous TAC code still valid. Please request new TAC code after 3 minutes.",
  tac_expired: "Your TAC code is expired. Please request new TAC code.",
  invalid_tac: "Invalid TAC code.",
  member_id_required: "Member Id is required.",
  invalid_date_range: "Invalid date range.",
  tac_code_required: "TAC code is required.",


};
